import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideZoneChangeDetection,
} from '@angular/core';

import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withPreloading,
} from '@angular/router';

import { routes } from './app.routes';
import {
  provideClientHydration,
  withHttpTransferCacheOptions,
  withIncrementalHydration,
} from '@angular/platform-browser';

import {
  HttpClient,
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { SHARED } from './shared/shared';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from '@ngx-translate/core';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { authInterceptor } from './core/services/auth.interceptor';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { AuthService } from './core/services/auth/auth.service';
import { MessageService } from 'primeng/api';

// Custom preset: Override Aura's default emerald primary color with red
const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      100: '#EAF4FB', // lighter color
      200: '#D6EAF7',
      300: '#BBE1FA', // light color
      400: '#7FB9E2',
      500: '#3282B8', // primary color
      600: '#1F6A9C',
      700: '#0F4C75', // active color
      800: '#24343D',
      900: '#1B262C', // dark color
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withPreloading(PreloadAllModules)
    ),
    provideAnimations(),
    provideClientHydration(
      withIncrementalHydration(),
      withHttpTransferCacheOptions({
        includePostRequests: true,
      })
    ),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    // provideServiceWorker('ngsw-worker.js', {
    //   enabled: environment.enableServiceWorker,
    //   registrationStrategy: 'registerWhenStable:30000',
    //   // Don't block app initialization on service worker registration
    // }),

    // provideServiceWorker('push-sw.js', {
    //   enabled: environment.enableServiceWorker,
    //   registrationStrategy: 'registerWhenStable:30000',
    // }),
    provideToastr(),
    provideNzI18n(en_US),
    // {
    //   provide: 'APP_STARTUP',
    //   useFactory: async () => {
    //     const authService = inject(AuthService);
    //     await authService.initialize();
    //   },
    // },
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MyPreset, // Using custom preset with red primary color
        options: {
          darkModeSelector: false || 'none',
        },
      },
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: true, // or environment.production
    }),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),

    SHARED,
    TranslateService,
    TranslateStore,
    MessageService,
  ],
};
